/**
 * @typedef photoPost
 * @type {object}
 * @property {number} id
 * @property {string} note
 * @property {string} image_url
 */

import logger from "../helpers/logger";
import directUpload from "../helpers/directUpload";

const formatData = data => ({
  photo_post: {
    note: data.photo_post.note
  }
});

export default {
  namespaced: true,
  state: {
    /** @type {photoPost} */
    list: {},
    listArr: [],
    myList: {},
    myListArr: [],
    myTotal: 0
  },
  mutations: {
    setData(state, payload) {
      state.list = payload.list;
      state.listArr = Object.keys(state.list)
        .map(Number)
        .sort((a, b) => a - b);
    },
    setMyData(state, payload) {
      state.myList = payload.myList;
      state.myListArr = Object.keys(state.myList)
        .map(Number)
        .sort((a, b) => a - b);
      state.myTotal = payload.myTotal;
    }
  },
  actions: {
    getMyPhotoPosts({ commit, state }, { limit }) {
      return new Promise(resolve => {
        const parameter = {};

        if (limit) {
          parameter.count = limit;
        }
        if (state.myListArr.length) {
          parameter.last = state.myListArr[state.myListArr.length - 1];
        }
        const query = Object.entries(parameter).map(e => `${e[0]}=${encodeURI(e[1])}`).join("&");

        let url = "photo_posts";
        if (query) {
          url = `${url}?${query}`;
        }

        this._vm.$http("get", url).then(res => {
          if (res.status === 200) {
            const newData = { ...state };

            newData.myTotal = res.result.total;
            res.result.photo_posts.forEach(item => {
              newData.myList[item.id] = item;
            });

            commit("setMyData", newData);
            console.log(state.myTotal);
          }

          resolve(true);
        });
      });
    },
    getPhotoPosts({ commit, state }, { limit }) {
      return new Promise(resolve => {
        const parameter = {};

        if (limit) {
          parameter.count = limit;
        }
        if (state.listArr.length) {
          parameter.last = state.listArr[state.listArr.length - 1];
        }
        const query = Object.entries(parameter).map(e => `${e[0]}=${encodeURI(e[1])}`).join("&");

        let url = "photo_posts/all";
        if (query) {
          url = `${url}?${query}`;
        }

        this._vm.$http("get", url).then(res => {
          if (res.status === 200) {
            const newData = { ...state };

            res.result.photo_posts.forEach(item => {
              newData.list[item.id] = item;
            });

            commit("setData", newData);
          }

          resolve(true);
        });
      });
    },
    async postPhotoPost({ commit, dispatch, state }, data) {
      const finalData = formatData(data);

      dispatch("setBusy", true, { root: true });
      const images = await directUpload([data.photo_post.img.file], this._vm.$http);
      finalData.image = images[0];

      if (process.env.VUE_APP_ENV !== "production") {
        logger("[Body]", finalData);
      }

      const res = await this._vm.$http("post", "photo_posts", finalData, false);
      dispatch("setBusy", false, { root: true });

      if (res.status === 201) {
        const { id } = res.result.photo_post;
        const newData = { ...state };

        newData.list[id] = res.result.photo_post;
        newData.myList[id] = res.result.photo_post;

        commit("setData", newData);
        commit("setMyData", newData);
        dispatch("setToast", { type: "success", msg: "写真を投稿しました" }, { root: true });
        return id;
      }

      return null;
    },
    async putPhotoPost({ commit, dispatch, state }, { id, data }) {
      const finalData = formatData(data);

      dispatch("setBusy", true, { root: true });

      const res = await this._vm.$http("put", `photo_posts/${id}`, finalData, false);
      dispatch("setBusy", false, { root: true });
      if (res.status === 200) {
        const newData = { ...state };

        newData.list[id] = {
          ...newData.list[id],
          note: finalData.photo_post.note
        };
        newData.myList[id] = {
          id,
          ...finalData.photo_posts
        };

        commit("setData", newData);
        commit("setMyData", newData);
        dispatch("setToast", { type: "success", msg: "更新しました" }, { root: true });
        return true;
      }

      return false;
    },
    async deletePhotoPost({ commit, dispatch, state }, id) {
      dispatch("setBusy", true, { root: true });
      const res = await this._vm.$http("delete", `photo_posts/${id}`);

      dispatch("setBusy", false, { root: true });
      if (res.status === 200) {
        const newData = { ...state };
        delete newData.list[id];
        delete newData.myList[id];

        commit("setData", newData);
        commit("setMyData", newData);
        return true;
      }

      return false;
    },
    async postFavorite({ commit, dispatch, state }, id) {
      dispatch("setBusy", true, { root: true });
      const res = await this._vm.$http("post", `photo_posts/${id}/likes`);

      dispatch("setBusy", false, { root: true });
      if (res.status === 200) {
        const newData = { ...state };
        newData.list[id] = {
          ...newData.list[id],
          is_liked: true
        };

        commit("setData", newData);
        return true;
      }

      return false;
    },
    async deleteFavorite({ commit, dispatch, state }, id) {
      dispatch("setBusy", true, { root: true });
      const res = await this._vm.$http("delete", `photo_posts/${id}/likes`);

      dispatch("setBusy", false, { root: true });
      if (res.status === 200) {
        const newData = { ...state };
        newData.list[id] = {
          ...newData.list[id],
          is_liked: false
        };

        commit("setData", newData);
        return true;
      }

      return false;
    },
  },
  getters: {
    sortedPhotoPosts: state => state.listArr.sort((a, b) => b - a).map(id => state.list[id]),
    sortedMyPhotoPosts: state => state.myListArr.sort((a, b) => b - a).map(id => state.myList[id]),
    myPhotoPostsTotal: state => state.myTotal,
    hasPhotoPosts: state => state.listArr.length > 0,
    hasMyPhotoPosts: state => state.myListArr.length > 0,
  }
};
